import { Component, OnInit, inject } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { MenuModule } from 'primeng/menu';
import { ButtonModule } from 'primeng/button';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth/auth.service';
import { UserService } from 'src/app/services/user/user.service';
import { UserData } from 'src/app/services/user/user.model';

@Component({
    selector: 'user-menu',
    templateUrl: './user-menu.component.html',
    standalone: true,
    imports: [MenuModule, ButtonModule]
})
export class UserMenu implements OnInit {

    userName: string = '';
    userService = inject(UserService);

    items: MenuItem[] | undefined;
    authService = inject(AuthService);
    router = inject(Router); ngOnInit() {
        this.fetchUserName();
        this.items = [
            {
                label: 'Settings',
                items: [
                    {
                        label: 'Profile',
                        icon: 'pi pi-user',
                        command: () => this.router.navigate(['/profile'])
                    },
                    {
                        label: 'Logout',
                        icon: 'pi pi-sign-out',
                        command: () => this.onLogout()
                    }
                ]
            }
        ];
    }

    onLogout() {
        this.authService.logout().subscribe({
            next: () => {
                this.router.navigate(['/auth/login']);
            },
            error: (error) => {
                console.error('Logout failed', error);
            },
        });
    }

    fetchUserName() {
        const userId = localStorage.getItem('id');
        if (!userId) return;
        this.userService.getUser(userId).subscribe({
            next: ({ data }) => {
                if (data?.name) this.userName = data.name;
            }
        });
    }
}